import { modals } from '@mantine/modals';
import { get } from 'lodash';

import { deleteIcon, viewIcon } from '@assets';
import { TableActions, TableColumnProps } from '@components';

export const useGoodsItemsListColumns = ({ consignmentForm, isMaster, houseRef, openGoodsItem, disabled, selectedRow }) => {
  const handleItemDelete = (row) => {
    const { consignmentItemIdx = -1 } = row || {};
    const consignmentItemsPath = isMaster ? `master.consignmentItems` : `houseConsignment.${houseRef}.consignmentItems`;
    consignmentForm.setFieldValue(
      consignmentItemsPath,
      get(consignmentForm.values, consignmentItemsPath).filter((_, idx) => idx !== consignmentItemIdx),
    );
    selectedRow.current = null;
  };

  const openDeleteGoodsItem = (row) => {
    modals.openConfirmModal({
      title: 'Confirm item delete',
      children: <div>Are you sure you want to delete this goods item?</div>,
      labels: { confirm: 'Delete', cancel: 'Cancel' },
      confirmProps: { color: 'red' },
      onConfirm: () => handleItemDelete(row),
    });
  };

  const actionList = (row, index) => {
    return [
      {
        icon: viewIcon,
        text: 'Edit',
        onClick: () => {
          openGoodsItem(row);
        },
        disableAfterClick: false,
      },
      {
        if: !disabled,
        icon: deleteIcon,
        text: 'Delete',
        onClick: () => openDeleteGoodsItem(row),
        disableAfterClick: false,
      },
    ];
  };

  const columns: TableColumnProps<any>[] = [
    {
      name: 'Goods Item Number',
      cell: (row) => row.goodsItemNumber,
    },
    {
      name: 'Description of goods',
      cell: (row) => row.descriptionOfGoods,
    },
    {
      name: 'HS code',
      cell: (row) => row.harmonizedSystemSubHeadingCode,
    },
    {
      name: 'Combined nomenclature code',
      cell: (row) => row.combinedNomenclatureCode,
    },
    {
      name: 'CUS Code',
      cell: (row) => row.cusCode,
    },
    {
      name: 'Gross mass',
      cell: (row) => row.grossMass,
    },
    {
      name: 'Actions',
      sticky: 'right',
      cell: (row, rowIndex) => (
        <TableActions
          actions={actionList(row, rowIndex)}
          secondaryActions={[]}
          onClick={() => {
            selectedRow.current = row;
          }}
          disableAfterClick={true}
        />
      ),
    },
  ];

  return { columns };
};
